import { useEffect, useRef } from 'react';
import { useDesignerStore } from '../store/designerStore';
import { useAppStore, themeClass } from '../store/appStore';
import { EntityForm, RelationshipForm, DesignerPreview, DesignerToolbar, DesignerValidation, TemplatePicker } from './designer';

export function OntologyDesigner() {
  const { ontology, setOntologyName, setOntologyDescription, undo, redo } = useDesignerStore();
  const theme = useAppStore((s) => s.theme);
  const isEmpty = ontology.entityTypes.length === 0 && ontology.relationships.length === 0;
  const pageRef = useRef<HTMLDivElement>(null);

  // Bound to the page element, not window: the host page owns its own shortcuts.
  useEffect(() => {
    const page = pageRef.current;
    if (!page) return;

    const handler = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod || e.key !== 'z') return;
      e.preventDefault();
      if (e.shiftKey) {
        redo();
      } else {
        undo();
      }
    };

    page.addEventListener('keydown', handler);
    return () => page.removeEventListener('keydown', handler);
  }, [undo, redo]);

  return (
    <div className={`designer-page ${themeClass(theme)}`} ref={pageRef} tabIndex={-1}>
      {/* Top bar */}
      <div className="designer-topbar">
        <div className="designer-meta-fields">
          <input
            className="designer-meta-name"
            type="text"
            value={ontology.name}
            onChange={(e) => setOntologyName(e.target.value)}
            placeholder="Ontology name"
          />
          <input
            className="designer-meta-desc"
            type="text"
            value={ontology.description}
            onChange={(e) => setOntologyDescription(e.target.value)}
            placeholder="Description"
          />
        </div>
        <DesignerToolbar />
      </div>

      {/* Split pane */}
      <div className="designer-split">
        {/* Left: editor forms */}
        <div className="designer-sidebar">
          {isEmpty && <TemplatePicker />}
          <DesignerValidation />
          <EntityForm />
          <RelationshipForm />
        </div>

        {/* Right: live preview */}
        <DesignerPreview />
      </div>
    </div>
  );
}
